module.exports = flarum.core.compat['common/helpers/textContrastClass'];